// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.submission-period-label{white-space:nowrap}`, "",{"version":3,"sources":["webpack://./src/EmploymentBillboard/Manager/Requests/DataviewTable/SubmissionPeriodLabel.scss"],"names":[],"mappings":"AAAA,yBACI,kBAAA","sourcesContent":[".submission-period-label{\r\n    white-space: nowrap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
